<p-dropdown [options]="list" [(ngModel)]="selectedItem" optionLabel="name" [filter]="true" filterBy="name" [showClear]="true"
            [placeholder]="placeHolderLanguage" (onChange)="feedback()" [style]="{'width':'100%', 'font-size':'45px'}"  [disabled]="disabled">
</p-dropdown>

